(() => {
  const configuredVideos = new WeakSet();

  const isVisible = (video) => {
    const rect = video.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  };

  const playAtStorefrontSpeed = (video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.preload = 'auto';
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.playbackRate = 1.3;
    video.defaultPlaybackRate = 1.3;

    const fitBackpackFrame = () => {
      const product = video.closest('.mirage-product--backpack');
      const item = video.closest('.product-slideshow__item--video');
      if (!product || !item || !video.videoWidth || !video.videoHeight) return;

      const sourceRatio = video.videoWidth / video.videoHeight;
      if (sourceRatio <= 1.05) {
        const controlledRatio = Math.max(sourceRatio, 0.75);
        item.classList.add('mirage-product-video--portrait');
        item.style.setProperty('--mirage-backpack-video-ratio', String(controlledRatio));
      }
    };

    const start = () => {
      video.playbackRate = 1.3;
      fitBackpackFrame();
      if (!document.hidden && isVisible(video)) video.play().catch(() => {});
    };

    if (!configuredVideos.has(video)) {
      configuredVideos.add(video);
      video.addEventListener('loadedmetadata', start);
      video.addEventListener('canplay', start);
      video.addEventListener('pause', () => {
        if (!document.hidden && isVisible(video)) window.setTimeout(start, 80);
      });
    }

    if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) video.load();
    start();
  };

  const initialise = (root = document) => {
    if (root.matches && root.matches('.mirage-product-autoplay-video')) playAtStorefrontSpeed(root);
    root.querySelectorAll?.('.mirage-product-autoplay-video').forEach(playAtStorefrontSpeed);
  };

  document.addEventListener('DOMContentLoaded', () => {
    initialise();
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initialise(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) initialise();
    });

    window.addEventListener('scroll', () => initialise(), { passive: true });
    window.addEventListener('resize', () => initialise(), { passive: true });
    document.addEventListener('click', () => window.setTimeout(initialise, 120), true);

    window.setTimeout(initialise, 600);
    window.setTimeout(initialise, 1800);
  });
})();
